__turbopack_context__.v({
  "currentButton": "LanguageSwitcher-module-scss-module__QWMOGW__currentButton",
  "dropdown": "LanguageSwitcher-module-scss-module__QWMOGW__dropdown",
  "dropdownItem": "LanguageSwitcher-module-scss-module__QWMOGW__dropdownItem",
  "switcher": "LanguageSwitcher-module-scss-module__QWMOGW__switcher",
});
